<template>
  <div class="custom_dialog" v-if="show">
    <div class="custom_content">
      <div class="content">
        <div class="icon_box">
          <iconpark-icon name="emotion-unhappy" class="icon error" v-if="status=='error'"></iconpark-icon>
          <iconpark-icon name="emotion-happy-a1pck9ee" class="icon success" v-else></iconpark-icon>
        </div>
        <p class="message_box">{{ message }}</p>
        <!-- <button @click="handleConfirm">确定</button> -->
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>
  
<style lang="less" scoped>
@import "/src/css/base.css";
.custom_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  // transform: translate(-50%,-50%);
}
.custom_content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
}
.custom_content .content{
  display: flex;
  align-items: center;
}
.custom_content .content .icon_box .icon{
  font-size: 40px;
}
.custom_content .content .icon_box .icon.error{
  color: red;
}
.custom_content .content .icon_box .icon.success{
  color: #67c23a;
}
.custom_content .content .message_box{
  font-size: 18px;
  color: #666;
  margin-left: 20px;
}
.custom_dialog button {
  margin-top: 10px;
}
</style>